/**
 * Flow brand mark — teal rounded tile with the double wave.
 * Use in chat avatars, wizard headers, approval cards, onboarding splash.
 */

interface Props {
  size?: number;
  className?: string;
}

export function WaveMark({ size = 24, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="32" height="32" rx="7" fill="var(--teal-500)" />
      <path
        d="M6 18 Q 10 10, 14 18 T 22 18"
        stroke="#fdfbf5"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M6 22 Q 10 14, 14 22 T 22 22"
        stroke="#fdfbf5"
        strokeOpacity="0.45"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
